const style = {
  chatContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    padding: "15px 20px",
    boxSizing: "border-box",
    cursor: "pointer",
    borderBottom: "1px solid #2a2f3b",
    transition: "background-color 0.2s ease",
  },
  activeChat: {
    background: "#2a2f3b",
  },
  notSeenChat: {
    background: "#1e2a3a",
  },
  profilePhotoBox: {
    width: 50,
    height: 50,
    minWidth: 50,
    borderRadius: "50%",
    overflow: "hidden",
    marginRight: "15px",
  },
  profilePhoto: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  info: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    overflow: "hidden",
    gap: "6px", // Aumentei o espaçamento para um respiro
  },
  nameAndTime: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  // O estilo nameAndStatus não é mais necessário aqui
  clientName: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#FFF",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "200px", // Limita o nome para não empurrar a hora
  },
  hour: {
    fontSize: "12px",
    color: "#aeb9c4",
    marginLeft: "10px", // Garante uma distância mínima do nome
  },
  clientLastMessage: {
    width: "100%",
    display: "flex", // Transformado em container flex
    justifyContent: "space-between", // Itens se afastam
    alignItems: "center", // Alinhamento vertical
    gap: "10px", // Espaço entre a mensagem e a tag
  },
  message: {
    fontSize: "14px",
    color: "#aeb9c4",
    whiteSpace: "nowrap",
    textAlign: "start",
    overflow: "hidden",
    textOverflow: "ellipsis",
    flexGrow: 1, // Permite que a mensagem ocupe o espaço disponível
  },
  notSeenMessage: {
    color: "#FFF",
    fontWeight: "bold",
  },
  leadStatusTag: {
    padding: "2px 8px",
    borderRadius: "12px",
    fontSize: "10px", // Um pouco menor para ficar mais delicado
    fontWeight: "bold",
    color: "#FFFFFF",
    textTransform: "uppercase",
    whiteSpace: "nowrap", // Impede que a tag quebre linha
    flexShrink: 0, // Impede que a tag seja espremida
  },
  leadStatusColors: {
    "Lead Quente": "#e53e3e", // Vermelho
    "Pausado": "rgba(80, 80, 80, 1)", // Vermelho
    "Lead Morno": "#dd6b20", // Laranja
    "Lead Frio": "#3182ce", // Azul
    "Venda Feita": "#38a169", // Verde
    Desentendimento: "#718096", // Cinza
    "Necessita Ajuda": "#d69e2e", // Amarelo/Dourado
    Default: "#4A5568", // Cor Padrão
  },
};

export default style;
